export const PRICE_LIST_EXPORT_ID = 'price-list';

export const PRICE_LIST_TITLE = 'Listas';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  type: 'Tipo',
  statusId: 'Estado',
};
